module.exports = __webpack_public_path__ + "static/media/icon_ubicacion.547a9609.svg";